<div class="tile">
  <h5>{{ 'savings-plan.most-chosen.MOST_CHOSEN_HEADER' | transloco }}</h5>
  <div class="row">
    <div class="col-12">
      <div class="nav nav-tabs mt-1">
        <div class="nav-item">
          <a
            data-zid="most-chosen-ETF"
            class="nav-link cursor-pointer font-medium"
            [class.active]="currentType === type.Etf"
            (click)="currentType = type.Etf"
          >
            {{ 'savings-plan.most-chosen.tabs.etfs' | transloco }}
          </a>
        </div>
        <div class="nav-item">
          <a
            data-zid="most-chosen-fonds"
            class="nav-link cursor-pointer font-medium"
            [class.active]="currentType === type.Funds"
            (click)="currentType = type.Funds"
          >
            {{ 'savings-plan.most-chosen.tabs.funds' | transloco }}
          </a>
        </div>
        <div class="nav-item">
          <a
            data-zid="most-chosen-aktien"
            class="nav-link cursor-pointer font-medium"
            [class.active]="currentType === type.Share"
            (click)="currentType = type.Share"
          >
            {{ 'savings-plan.most-chosen.tabs.stocks' | transloco }}
          </a>
        </div>
        <div class="nav-item">
          <a
            data-zid="most-chosen-kryptos"
            class="nav-link cursor-pointer font-medium"
            [class.active]="currentType === type.Crypto"
            (click)="currentType = type.Crypto"
          >
            {{ 'savings-plan.most-chosen.tabs.crypto' | transloco }}
          </a>
        </div>
      </div>
    </div>
    <div class="col-12">
      @for (savingPlan of (savingplanFacade.mostChosenSavingPlans$ | async)[currentType] | slice: 0 : 7; track $index) {
        <saving-plans-saving-plan-most-chosen-item [savingPlan]="savingPlan" />
      }
    </div>
  </div>
</div>
